<app-block-wrapper [_editable]="_editable" [style]="style()">
  <div
    class="teaser image-{{ assetPosition }} asset-size-{{ assetSize }}"
    [class.image-out-of-frame]="assetOutOfFrame"
    [class.hide-asset-on-mobile]="hideAssetOnMobile"
    [appStoryblok]="_editable"
  >
    @if (dimensions && asset()?.image) {
      <div animateInView="up" class="teaser-asset">
        @if (deferAsset()) {
          @defer (on viewport) {
            <ng-container [ngTemplateOutlet]="picture" />
          } @placeholder {
            <div
              class="teaser-asset-placeholder br-{{ borderRadius }}"
              [style.aspect-ratio]="dimensions().width + ' / ' + dimensions().height"
            ></div>
          }
        } @else {
          @defer (hydrate never) {
            <ng-container [ngTemplateOutlet]="picture" />
          }
        }
      </div>
      <ng-template #picture>
        <app-picture
          class="br-{{ borderRadius }}"
          [scale]="0.5"
          [class.shadow-box]="shadowBox"
          [loading]="priorityImage() ? 'eager' : 'lazy'"
          [preload]="priorityImage()"
          [url]="asset().image.filename | storyblokCdn"
          [maxWidth]="maxWidth()"
          [width]="dimensions().width"
          [height]="dimensions().height"
          [alt]="asset().image.alt || ''"
          [appStoryblok]="asset()._editable"
        >
          @if (assetBackground?.filename) {
            <img [src]="assetBackground.filename | storyblokCdn" [alt]="assetBackground.alt" class="teaser-asset-bg" />
          }
        </app-picture>
      </ng-template>
    } @else if (dimensions && asset()?.video?.filename) {
      <video
        class="br-{{ borderRadius }}"
        autoplay
        loop
        muted
        playsinline
        disablepictureinpicture="true"
        [class.shadow-box]="shadowBox"
        [width]="dimensions().width"
        [height]="dimensions().height"
        [poster]="asset().poster?.filename | storyblokCdn"
        [appStoryblok]="asset()._editable"
      >
        <source [src]="asset().video.filename | storyblokCdn" type="video/mp4" provider="html5" size="1080" />
      </video>
    } @else if (hasAnimation()) {
      <div animateInView="up" class="teaser-asset" [appStoryblok]="asset()._editable">
        <app-animation-host
          [animation]="asset().animation"
          [width]="dimensions().width"
          [height]="dimensions().height"
        />
      </div>
    } @else {
      <div [appStoryblok]="asset()?._editable" class="asset-placeholder"></div>
    }
    <div class="teaser-content">
      @for (blok of content; track blok._uid) {
        <ndc-dynamic
          [ndcDynamicComponent]="$any(components[blok.component])"
          [ndcDynamicInputs]="$any(blok)"
        ></ndc-dynamic>
      }
      @if (cta && cta.link?.startsWith('/')) {
        <a class="primary-link with-arrow" animateInView="up" [routerLink]="cta.link" [appStoryblok]="cta._editable">
          {{ cta.text }}
        </a>
      }
      @if (cta && !cta.link?.startsWith('/')) {
        <a
          class="primary-link with-arrow"
          animateInView="up"
          [href]="cta.link"
          target="_blank"
          [appStoryblok]="cta._editable"
        >
          {{ cta.text }}
        </a>
      }
    </div>
  </div>
</app-block-wrapper>
